export const getMandatoryDeclationTextsArray = (recipeDetails) => {
  const textArray = []
  recipeDetails?.more_polyols &&
    textArray.push("Polyols may have laxative effect")
  recipeDetails?.more_polydextrose &&
    textArray.push("Polydextrose may have laxative effect")
  recipeDetails?.caffeine_added && textArray.push("Contains caffeine")
  recipeDetails?.monosodium_glutamate &&
    textArray.push(`This product contains added MONOSODIUM GLUTAMATE. 
         NOT RECOMMENDED FOR INFANTS BELOW 12 MONTHS AND PREGNANT WOMEN.`)
  recipeDetails?.plant_stanols_esters &&
    recipeDetails?.plant_stanol_amount &&
    textArray.push(`Contains Plant Stanol Esters (as Plant Stanols) 
            ${recipeDetails?.plant_stanol_amount} gm/100 gm or 100ml.
            Patients on cholesterol lowering medication should use
            the product under medical supervision. May not be
            nutritionally appropriate for pregnant and lactating
            women and children under the age of five years.
            CONSUMPTION OF MORE THAN 3g. PER DAY, TOTAL OF STEROL,
            STANOLS OR COMBINATION THEREOF SHALL BE AVOIDED.`)
  recipeDetails?.non_caloric_sweetener &&
    textArray.push(`CONTAINS
          ${recipeDetails.all_sweetners.join(", ")}.
          CONTAINS NON-CALORIC SWEETENER.`)

  recipeDetails?.ingredients?.forEach((ingredient) => {
    const declarations = ingredient?.mandatory_declarations || {}

    declarations.more_polyols &&
      textArray.push("Polyols may have laxative effect")
    declarations.more_polydextrose &&
      textArray.push("Polydextrose may have laxative effect")
    declarations.caffeine_added && textArray.push("Contains caffeine")
    declarations.monosodium_glutamate &&
      textArray.push(`This product contains added MONOSODIUM GLUTAMATE. 
                   NOT RECOMMENDED FOR INFANTS BELOW 12 MONTHS AND PREGNANT WOMEN.`)
    declarations.plant_stanols_esters &&
      declarations.plant_stanol_amount &&
      textArray.push(`Contains Plant Stanol Esters (as Plant Stanols) 
                      ${declarations.plant_stanol_amount} gm/100 gm or 100ml.
                      Patients on cholesterol-lowering medication should use
                      the product under medical supervision. May not be
                      nutritionally appropriate for pregnant and lactating
                      women and children under the age of five years.
                      CONSUMPTION OF MORE THAN 3g. PER DAY, TOTAL OF STEROL,
                      STANOLS OR COMBINATION THEREOF SHALL BE AVOIDED.`)
    declarations.non_caloric_sweetener &&
      textArray.push("Contains non-caloric sweetener.")
  })
  return textArray
}

export const mandatoryNutrients = [
  {
    key: "Energy",
    value: "Energy",
    per_dv: "Energy",
    text: "Energy (kcal)",
  },
  {
    key: "Carbohydrates",
    value: "Carbohydrates",
    text: "Total Carbohydrate (g)",
  },
  {
    key: "Free_Sugars",
    value: "Free_Sugars",
    text: "Total Sugars (g)",
  },
  {
    key: "Total_Free_Sugars",
    value: "Total_Free_Sugars",
    per_dv: "Total_Free_Sugars",
    text: "Added Sugars (g)",
  },
  {
    key: "Dietary_Fibre",
    value: "Dietary_Fibre",
    text: "Dietary Fiber (g)",
  },
  {
    key: "Protein",
    value: "Protein",
    text: "Protein (g)",
  },
  {
    key: "Total_Fat",
    value: "Total_Fat",
    per_dv: "Total_Fat",
    text: "Total Fat (g)",
  },
  {
    key: "Total_SFA",
    value: "Total_SFA",
    per_dv: "Total_SFA",
    text: "Saturated Fat (g)",
  },
  {
    key: "Trans_Fat",
    value: "Trans_Fat",
    per_dv: "Trans_Fat",
    text: "Trans Fat (g)",
  },
  {
    key: "Cholesterol",
    value: "Cholesterol",
    per_dv: "Cholesterol",
    text: "Cholesterol (mg)",
  },
  {
    key: "Sodium",
    value: "Sodium",
    per_dv: "Sodium",
    text: "Sodium (mg)",
  },
]

export const nonMandatoryNutrients = [
  {
    key: "Total_MUFA",
    value: "Total_MUFA",
    text: "MUFA (g)",
  },
  {
    key: "Total_PUFA",
    value: "Total_PUFA",
    text: "PUFA (g)",
  },
  {
    key: "Vit_A",
    value: "Vit_A",
    per_dv: "Vit_A",
    text: "Vitamin A (mcg)",
  },
  {
    key: "Vit_C_Ascorbic_Acid",
    value: "Vit_C_Ascorbic_Acid",
    per_dv: "Vit_C",
    text: "Vitamin C (mg)",
  },
  {
    key: "Iron",
    value: "Iron",
    per_dv: "Iron",
    text: "Iron (mg)",
  },
  {
    key: "Calcium",
    value: "Calcium",
    per_dv: "Calcium",
    text: "Calcium (mg)",
  },
  {
    key: "Potassium",
    value: "Potassium",
    per_dv: "Potassium",
    text: "Potassium (mg)",
  },
]

export const Allergen = {
  Milk: "Milk",
  Soy: "Soy",
  Nut: "Nut",
  wheat: "Wheat",
  Crustacean: "Crustacean",
  Egg: "Egg",
  Fish: "Fish",
  Sulphite: "Sulphite",
  Oat: "Oat",
}

export function getIngredientNames(recipeDetails) {
  const { ingredients } = recipeDetails

  const ingredientNamesFromIngredients = ingredients.map((ingredient, index) =>
    index !== ingredients.length - 1
      ? ingredient.ingredient_name + ","
      : ingredient.ingredient_name,
  )

  const allIngredientNames = [...ingredientNamesFromIngredients]
  return allIngredientNames
}

export function getAllergens(recipeDetails) {
  const { allergens } = recipeDetails

  const allergenList = allergens.map((allergen, index) =>
    index !== allergens.length - 1 ? allergen + "," : allergen,
  )

  const allAllergens = [...allergenList]
  return allAllergens
}

export const RECIPE_NI_KEYS = {
  ENERGY: "Energy",
  CARBOHYDRATES: "Carbohydrates",
  TOTAL_SUGAR: "Free_Sugars",
  DIETARY_FIBRE: "Dietary_Fibre",
  INSOLUBLE_FIBRE: "Insoluble_Fibre",
  SOLUBLE_FIBRE: "Soluble_Fibre",
  PROTEIN: "Protein",
  TOTAL_FAT: "Total_Fat",
  TOTAL_SFA: "Total_SFA",
  TRANS_FAT: "Trans_Fat",
  TOTAL_MUFA: "Total_MUFA",
  TOTAL_PUFA: "Total_PUFA",
  CHOLESTEROL: "Cholesterol",
  SODIUM: "Sodium",
  POTASSIUM: "Potassium",
  CALCIUM: "Calcium",
  IRON: "Iron",
  ZINC: "Zinc",
  PHOSPHORUS: "Phosphorus",
  MAGNESIUM: "Magnesium",
  MANGANESE: "Manganese",
  SELENIUM: "Selenium",
  CHROMIUM: "Chromium",
  COPPER: "Copper",
  ALUMINIUM: "Aluminium",
  ARSENIC: "Arsenic",
  CADMIUM: "Cadmium",
  COBALT: "Cobalt",
  LEAD: "Lead",
  LITHIUM: "Lithium",
  MERCURY: "Mercury",
  MOLYBDENUM: "Molybdenum",
  NICKEL: "Nickel",
  VIT_A_RETINOL: "Vit_A_Retinol",
  VIT_A_CAROTENOIDS: "Vit_A_Carotenoids",
  VIT_A: "Vit_A",
  VIT_D: "Vit_D",
  LUTEIN: "Lutein",
  ZEAXANTHIN: "Zeaxanthin",
  LYCOPENE: "Lycopene",
  BETA_CRYPTOXANTHIN: "β_Cryptoxanthin",
  GAMMA_CAROTENE: "γ_Carotene",
  ALPHA_CAROTENE: "α_Carotene",
  BETA_CAROTENE: "β_Carotene",
  VIT_D3_CHOLECALCIFEROL: "Vit_D3_Cholecalciferol",
  VIT_D2_ERGOCALCIFEROL: "Vit_D2_Ergocalciferol",
  VIT_E_ALPHA_TOCOPHEROL: "Vit_E_α_Tocopherol",
  ALPHA_TOCOPHEROLS: "α_Tocopherols",
  BETA_TOCOPHEROLS: "β_Tocopherols",
  GAMMA_TOCOPHEROLS: "γ_Tocopherols",
  DELTA_TOCOPHEROLS: "δ_Tocopherols",
  ALPHA_TOCOTRIENOLS: "α_Tocotrienols",
  BETA_TOCOTRIENOLS: "β_Tocotrienols",
  GAMMA_TOCOTRIENOLS: "γ_Tocotrienols",
  DELTA_TOCOTRIENOLS: "δ_Tocotrienols",
  PHYLLOQUINONES: "Phylloquinones",
  MENAQUINONES: "Menaquinones",
  VIT_B1_THIAMINE: "Vit_B1_Thiamine",
  VIT_B2_RIBOFLAVIN: "Vit_B2_Riboflavin",
  VIT_B3_NIACIN: "Vit_B3_Niacin",
  VIT_B5_PANTOTHENIC_ACID: "Vit_B5_Pantothenic_Acid",
  VIT_B6_PYRIDOXINE: "Vit_B6_Pyridoxine",
  BIOTIN: "Biotin",
  VIT_B9_FOLATE: "Vit_B9_Folate",
  VIT_C_ASCORBIC_ACID: "Vit_C_Ascorbic_Acid",
  BUTYRIC_ACID: "Butyric_Acid",
  CAPROIC_ACID: "Caproic_Acid",
  CAPRYLIC_ACID: "Caprylic_Acid",
  CAPRIC_ACID: "Capric_Acid",
  UNDECANOIC_ACID: "Undecanoic_Acid",
  LAURIC_ACID: "Lauric_Acid",
  MYRISTIC_ACID: "Myristic_Acid",
  PENTADECANOIC_ACID: "Pentadecanoic_Acid",
  PALMITIC_ACID: "Palmitic_Acid",
  STEARIC_ACID: "Stearic_Acid",
  ARACHIDIC_ACID: "Arachidic_Acid",
  BEHENIC_ACID: "Behenic_Acid",
  LIGNOCERIC_ACID: "Lignoceric_Acid",
  MYRISTOLEIC_ACID: "Myristoleic_Acid",
  PALMITOLEIC_ACID: "Palmitoleic_Acid",
  ELAIDIC_ACID: "Elaidic_Acid",
  OLEIC_ACID: "Oleic_Acid",
  EICOSAENOIC_ACID: "Eicosaenoic_Acid",
  ERUCIC_ACID: "Erucic_Acid",
  NERVONIC_ACID: "Nervonic_Acid",
  LINOLEIC_ACID: "Linoleic_Acid",
  EICOSADIENOIC_ACID: "Eicosadienoic_Acid",
  ALPHA_LINOLENIC_ACID: "α_Linolenic_Acid",
  ARACHIDONIC_ACID: "Arachidonic_Acid",
  EICOSA_PENTADECANOIC_ACID: "Eicosa_pentadecanoic_Acid",
  DOCOSA_HEXENOIC_ACID: "Docosa_hexenoic_Acid",
  TOTAL_AVAILABLE_CHO: "Total_Available_CHO",
  TOTAL_STARCH: "Total_Starch",
  FRUCTOSE: "Fructose",
  GLUCOSE: "Glucose",
  SUCROSE: "Sucrose",
  MALTOSE: "Maltose",
  ADDED_SUGAR: "Total_Free_Sugars",
  HISTIDINE: "Histidine",
  ISOLEUCINE: "Isoleucine",
  LEUCINE: "Leucine",
  LYSINE: "Lysine",
  METHIONINE: "Methionine",
  CYSTINE: "Cystine",
  PHENYLALANINE: "Phenylalanine",
  THREONINE: "Threonine",
  TRYPTOPHAN: "Tryptophan",
  VALINE: "Valine",
  ALANINE: "Alanine",
  ARGININE: "Arginine",
  ASPARTIC_ACID: "Aspartic_Acid",
  GLUTAMIC_ACID: "Glutamic_Acid",
  GLYCINE: "Glycine",
  PROLINE: "Proline",
  SERINE: "Serine",
  TYROSINE: "Tyrosine",
  MOISTURE: "Moisture",
  ASH: "Ash",
  ENERGY_KJ: "Energy_KJ",
}
